import React from 'react'
import { SidebarContainer, Icon, CloseIcon, SidebarMenu, SidebarWrapper, SidebarLink, SidebarRoute, SideBtnWrap} from './SidebarElements'

const SponsorSidebar = ({isOpen, toggle}) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
            <CloseIcon />
        </Icon>
        <SidebarWrapper>
            <SidebarMenu>
                <SidebarLink to="our sponsors" onClick={toggle} smooth="true"  exact="true" offset={-80} >
                    Community
                </SidebarLink>
                <SidebarLink to="SIG" onClick={toggle} smooth="true"  exact="true" offset={-80} >
                    Our Sponsors
                </SidebarLink>
                <SidebarLink to="sponsor us" onClick={toggle} smooth="true"  exact="true" offset={-80} >
                    Sponsor Us
                </SidebarLink>
                <SideBtnWrap>
                    <SidebarRoute to="/signin" onClick={toggle} smooth="true"  exact="true" offset={-80} >
                        Sign in
                    </SidebarRoute>
                </SideBtnWrap>
            </SidebarMenu>
        </SidebarWrapper>
    </SidebarContainer>
  )
}

export default SponsorSidebar